export enum Languagei18n {
  PORTUGUESE = 'pt',
  ENGLISH = 'en',
  SPANISH = 'es',
}
